import { SiteUtilities } from './utils';

var customCarousel = function ($ = jQuery) {
  $('.carousel').carousel({
    pause: true,
    interval: false
  }).on('slide.bs.carousel', function (e) {
    var nextItem = $(e.relatedTarget).height();
    $(this).find('.active.item').parent().animate({ height: nextItem }, 500);
  }).on('slid.bs.carousel', function () {
    $(this).find('.carousel-item').each(function () {
      this.setAttribute('aria-hidden', !$(this).hasClass('active'));
    });
    $(this).find('.carousel-indicators').children().each(function () {
      this.setAttribute('aria-selected', $(this).hasClass('active'));
    });
  });

  setTimeout(() => {
    const $testimonialHome = $('.testimonial-home');
    const $carouselInner = $testimonialHome.find('.carousel-inner');
    const $carouselItems = $testimonialHome.find('.carousel-item');
    const itemHeights = [];
    $carouselItems.each(function () {
      itemHeights.push($(this).outerHeight());
    });
    $carouselInner.height(Math.max(...itemHeights));
    $carouselItems.height(Math.max(...itemHeights));
  }, 2000);

  $('.carousel-indicators').find('li[role="tab"]').on('keypress', function (e) {
    const isSubmit = SiteUtilities.keyTriggered(e, 'SUBMIT');
    if (isSubmit) {
      e.preventDefault();
      this.click();
    }
  });
};

export { customCarousel };
